import { render, staticRenderFns } from "./contractDetailOwner.vue?vue&type=template&id=303be0ac&scoped=true"
import script from "./contractDetailOwner.vue?vue&type=script&lang=js"
export * from "./contractDetailOwner.vue?vue&type=script&lang=js"
import style0 from "./contractDetailOwner.vue?vue&type=style&index=0&id=303be0ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303be0ac",
  null
  
)

export default component.exports